module.exports = __webpack_public_path__ + "img/join4-5.f6181bb3.svg";